import React from 'react';

import noop from 'lodash/noop';

import {
  constants as virtualCardConstants,
  hooks as virtualCardHooks,
} from '@ott/shared-virtual-card-logic';

import DetailsModal from '../DetailsModal';
import NotEnoughBalanceModal from '../NotEnoughBalanceModal';
import RefillModal from '../RefillModal';
import ReleaseModal from '../ReleaseModal';
import TransferModal from '../TransferModal';
import UpgradeModal from '../UpgradeModal';

const { MODAL_TYPES } = virtualCardConstants;

const {
  virtualCardFlow: { useVirtualCardFlow },
} = virtualCardHooks;

const getModal = (type) => {
  switch (type) {
    case MODAL_TYPES.RELEASE:
      return ReleaseModal;
    case MODAL_TYPES.REFILL:
      return RefillModal;
    case MODAL_TYPES.NOT_ENOUGH_BALANCE:
      return NotEnoughBalanceModal;
    case MODAL_TYPES.UPGRADE:
      return UpgradeModal;
    case MODAL_TYPES.DETAILS:
      return DetailsModal;
    case MODAL_TYPES.TRANSFER:
      return TransferModal;

    default:
      return null;
  }
};

const VirtualCardModals = () => {
  const { modal, modalState, closeModal } = useVirtualCardFlow();

  const currentModalState = modalState[modal || ''] || {};
  const commonModalState = modalState?.common || {};

  const { onClose = noop, ...restState } = { ...commonModalState, ...currentModalState };

  const handleClose = () => {
    onClose?.();
    closeModal();
  };

  const Component: React.FC<any> | null = getModal(modal);

  return Component ? <Component {...restState} isOpen={true} onClose={handleClose} /> : null;
};

export default VirtualCardModals;
